// extracted by mini-css-extract-plugin
module.exports = {"container":"PTKUkrPPSRIo2NIRuhFN9","adviser-container":"_3V0gQ_T-YYExhlLhjs4GXz","adviser-name":"_1enD96ca1Mf5C0belV9drd","avatar":"_1MTR3cRh7RVe5ZeCbQ8gxu"};